import React from 'react'
import { SWRConfig } from 'swr'
import { swrConfig } from '@/lib/swr'
import { useTheme } from '@/hooks/useTheme'

function ThemeInitializer({ children }: { children: React.ReactNode }) {
  // Ensures theme is applied on mount
  useTheme()
  return <>{children}</>
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SWRConfig value={swrConfig}>
      <ThemeInitializer>{children}</ThemeInitializer>
    </SWRConfig>
  )
}
